import React from 'react';

import { GetPaymentHistoryPdfHandler_getPaymentHistoryPdf } from '@zg-rentals/ts-rent-payment-client';
import { usePdfFromRequester } from '@zg-rentals/pdf-utils';
import { Button } from '@zillow/constellation-10';
import { Toast, ToastProvider, useToast } from '@zillow/constellation';
import { IconPrintOutline } from '@zillow/constellation-icons';
import { logError } from '@zg-rentals/log-error';

const PaymentHistoryPdfButton: React.FC = () => {
  const { enqueueToast } = useToast();
  const { getPdf, isLoading: isPdfLoading } = usePdfFromRequester({
    openInNewTab: true,
    requester: GetPaymentHistoryPdfHandler_getPaymentHistoryPdf,
    onError: (error) => {
      logError({ error, context: 'PaymentHistoryPdfButton' });
      enqueueToast(<Toast role="status">Failed to generate payment history PDF</Toast>);
    },
  });

  const handleClick = () => {
    getPdf(undefined);
  };

  return (
    <Button
      size="sm"
      onClick={handleClick}
      loading={isPdfLoading}
      disabled={isPdfLoading}
      css={{ display: 'block', marginLeft: 'auto' }}
    >
      <IconPrintOutline style={{ marginRight: 8, verticalAlign: 'middle', width: 16, height: 16 }} />
      Print
    </Button>
  );
};

const WrappedPaymentHistoryPdfButton = () => (
  <ToastProvider>
    <PaymentHistoryPdfButton />
  </ToastProvider>
);

export default WrappedPaymentHistoryPdfButton;
